<template>
    <tr>
        <td>
            <span>{{ initialTranslation.id }}</span>
        </td>
        <td>
            <span>{{ initialTranslation.source }}</span>
        </td>
        <td>
            <span>{{ initialTranslation.component }}</span>
        </td>
        <td>
            <div style="width: 175px;">
                <app-button type="success" @click="save">
                    {{ isSaving ? 'Saving...' : 'Save' }}
                </app-button>
                <app-button type="error" confirm-message="Are you sure?" @click="remove">
                    {{ isDeleting ? 'Deleting...' : 'Delete' }}
                </app-button>
            </div>
        </td>
        <td v-for="item in items" style="min-width: 200px">
            <textarea class="form-control" v-model="item.translation">{{ item.translation }}</textarea>
        </td>
    </tr>
</template>
<script>
    export default {
        props: {
            initialTranslation: Object,
            index: Number,
            languages: {
                type: Array,
                required: true
            }
        },
        data() {
            let items = [];
            items.push(
                {
                    id: this.initialTranslation.id,
                    translation: this.initialTranslation.translation,
                    language_id: this.initialTranslation.language_id,
                    source: this.initialTranslation.source,
                    component: this.initialTranslation.component,
                }
            );

            this.languages.forEach(language => {
                let translation = '';
                let translationId = null;
                let languageId = language.id;

                this.initialTranslation.other_languages_translations.forEach(otherLangTrans => {
                    if (this.initialTranslation.source === otherLangTrans.source
                        && this.initialTranslation.component === otherLangTrans.component
                        && parseInt(language.id) === otherLangTrans.language_id
                    ) {
                        translation = otherLangTrans.translation;
                        translationId = otherLangTrans.id;
                        languageId = otherLangTrans.language_id;
                    }
                });
                if (language.id !== this.initialTranslation.language_id) {
                    items.push(
                        {
                            id: translationId,
                            translation: translation,
                            language_id: languageId,
                            source: this.initialTranslation.source,
                            component: this.initialTranslation.component,
                        }
                    );
                }
            });

            return {
                items: items,
                isSaving: false,
                isDeleting: false
            };
        },
        methods: {
            save() {
                this.isSaving = true;
                axios.put(route('translations.update'), {translations: this.items})
                    .then(() => {
                        this.isSaving = false;
                    })
                    .catch(() => {
                        this.isSaving = false;
                    });
            },
            remove() {
                this.isDeleting = true;
                axios.delete(route('translations.destroy', {translation: this.initialTranslation.id}))
                    .then(() => {
                        this.isDeleting = false;
                        this.$emit('deleteTranslation', this.initialTranslation.id, this.index);
                    })
                    .catch(() => {
                        this.isDeleting = false;
                    });
            },
        },
    }
</script>
